module.exports = __webpack_public_path__ + "img/falcao.941c37d0.jpg";